import { addWeightCalcAction } from "../redux/actions/weightCalcAction";

const ENDPOINT = {
  // auth API's
  userRegister: "/auth/user/signupByAdmin",
  adminRegister: "/auth/admin/signup",
  adminLogin: "/auth/admin/login",
  adminLogout: "/auth/logout",

  // admin API's
  getAdminList: "/admin/list",
  getAdminById: "/admin/singleAdmin",
  adminSignup: "/auth/admin/signup",
  getAdmin: "/auth/admin",
  updateAdmin: "/admin/update",
  deleteAdmin: "/admin/delete",
  changeAdminPassword: "/admin/changePassword",

  // Roles & Permissions API's
  getRoleList: "/role/list",
  AddRole: "/role/create",
  updateRole: "/role/update",
  deleteRole: "/role/delete",
  getPermissionList: "/permission/list",
  AddPermission: "/permission/create",
  updatePermission: "/permission/update",
  deletePermission: "/permission/delete",
  getPermission: "/permission/get",
  getRole: "/role/get",

  // Customer API's
  getCustomerList: "/user/list",
  updateCustomerProfile: "/user/update",
  deleteCustomer: "/user/delete",
  getUserProfile: "/user/profile",
  checkCustomerUsername: "/user/checkUsername",
  getUserById: "/user/singleUser",

  // Package API's
  addPackage: "/package/create",
  getPackageList: "/package/list",
  updatePackage: "/package/update",
  deletePackage: "/package/delete",
  getPackageById: "/package/singlePackage",

  // Event API's
  createEvent: "/event/create",
  updateEvent: "/event/update",
  getEventById: "/event/singleEvent",
  deleteEvent: "/event/delete",

  // Category API's
  getCategoryList: "/category/list",
  createCategory: "/category/create",
  updateCategory: "/category/update",
  deleteCategory: "/category/delete",
  getCategoryById: "/category/singleCategory",

  // Notification API's
  notificationList: "/notification/list",
  createNotificationForAdmin: "/notification/createNotificationForAdmin",
  notificationById: "/notification/notificationById",
  receiverNotificationList: "/notification/receiverList",
  deleteNotification: "/notification/delete",
  updateNotificationForAdmin: "/notification/updateNotificationForAdmin",
  deleteNotification: "/notification/delete",

  //Profession API's
  addProfession: "/profession/create",
  getProfessionList: "/profession/list",
  updateProfession: "/profession/update",
  deleteProfession: "/profession/delete",
  getProfessionById: "/profession/singleProfession",

  // Feedback API's
  getFeedList: "/feedback/list",
  deleteFeedback: "/feedback/delete",

  //WeightCalc API's
  addWeightCalc: "/weightCalc/create",
  getWeightCalcList: "/weightCalc/list",
  updateWeightCalc: "/weightCalc/update",
  deleteWeightCalc: "/weightCalc/delete",
  getWeightCalcById: "/weightCalc/singleWeight",

  // Interst API's
  addInterest: "/interest/create",
  getInterestList: "/interest/list",
  getInterestById: "/interest/singleInterest",
  updateInterest: "/interest/update",
  deleteInterest: "/interest/delete",

  // transaction API's
  deleteTransaction: "/transaction/delete",
  getTransactionsList: "/transaction/list",

  //kyc
  verifyKyc: "/kyc/verify",

  //wallet statement
  getWalletStateByUserId: "/wallet/statement/list",
};

export default ENDPOINT;
